import { formatPosition } from ".";
import { formatProductionPositionWorkload } from "./production-position-workload";
import { formatProductionPositionSalary } from "./production-position-salary";

export function formatProductionPosition(data) {
    const formattedData = {
        ...formatPosition(data),
        ...formatProductionPositionWorkload(data),
        ...formatProductionPositionSalary(data),
    };

    return formattedData;
}
